import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) return navigate("/portal", { replace: true });
    api
      .post("/portal/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } })
      .then(({ data }) => {
        localStorage.setItem("revora_portal", data.token);
        navigate("/portal/dashboard", { replace: true });
      })
      .catch(() => navigate("/portal", { replace: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center" data-testid="auth-callback">
      <p className="text-white/60 text-sm flex items-center gap-2">
        <Loader2 className="w-4 h-4 animate-spin" /> Completing sign in…
      </p>
    </div>
  );
}
